import { feature as asFeature, featureCollection as asFeatureCollection } from '@turf/helpers';
import { default as OlFeature } from 'ol/Feature';

import { SingleTaskWebWorkerApi } from 'cadenza/web-worker/single-task-web-worker-api';
import { olGeometryToGeoJsonGeometry } from 'cadenza/utils/geo-json';
import type { PolygonValidationError } from 'cadenza/map/polygon-validation/polygon-validation-error';

import type { Polygon as OlPolygon } from 'ol/geom';

export type Validatable = OlPolygon | OlFeature<OlPolygon> | (OlPolygon | OlFeature<OlPolygon>)[];

export class PolygonValidationWebWorker extends SingleTaskWebWorkerApi {

  async validate (validatable: Validatable) {
    const validatableArray = Array.isArray(validatable) ? validatable : [ validatable ];
    const geoJsonPolygonFeatureCollection = asFeatureCollection(validatableArray.map(toPolygonFeature));
    return await this.execute(geoJsonPolygonFeatureCollection) as PolygonValidationError | null;
  }

}

function toPolygonFeature (validatable: OlPolygon | OlFeature<OlPolygon>) {
  if (validatable instanceof OlFeature) {
    return asFeature(olGeometryToGeoJsonGeometry(validatable.getGeometry()));
  }
  return asFeature(olGeometryToGeoJsonGeometry(validatable));
}

export function spawnPolygonValidationWorker (): PolygonValidationWebWorker {
  return new PolygonValidationWebWorker(new Worker(new URL('./polygon-validation.worker.ts', import.meta.url)));
}

